import { Component, ElementRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.sass']
})
export class CalculatorComponent {
  @ViewChild('dateInp') dateInp: ElementRef
  data: TMatrix = {
    character: 0,
    energy: 0,
    interest: 0,
    health: 0,
    logic: 0,
    work: 0,
    luck: 0,
    dolg: 0,
    memory: 0,
    temp: 0,
    goal: 0,
    byt: 0,
    fam: 0,
    habits: 0,
    destinyNumb: null
  }
  activeTab: 'datepicker' | 'matrix' = 'datepicker'
  errMsg: string
  status: 'show' | null = null
  dateField = new FormControl()
  matrixField = new FormControl()

  get selectedDate() {
    return moment(this.dateField.value, 'DD.MM.YYYY', true).isValid()
      ? moment(this.dateField.value, 'DD.MM.YYYY').toDate()
      : null
  }

  get matrixString() {
    return `${this.returnString(this.data?.character, '1')  || '-'}/${this.returnString(this.data?.energy, '2') || '-'}/${this.returnString(this.data?.interest, '3') || '-'}/${this.returnString(this.data?.health, '4') || '-'}/${this.returnString(this.data?.logic, '5') || '-'}/${this.returnString(this.data?.work, '6') || '-'}/${this.returnString(this.data?.luck, '7') || '-'}/${this.returnString(this.data?.dolg, '8') || '-'}/${this.returnString(this.data?.memory, '9') || '-'}`
  }

  setDate(date: Date) {
    const day = new Date(date).getDate() > 9 ? new Date(date).getDate() : '0' + new Date(date).getDate()
    const month = new Date(date).getMonth() + 1 > 9 ? new Date(date).getMonth() + 1 : '0' + (new Date(date).getMonth() + 1)
    this.dateField.setValue(`${day}.${month}.${new Date(date).getFullYear()}`)
    this.errMsg = ''
  }

  getDate() {
    const date = this.dateField?.value?.replace(/\D/g, '')

    if (!date) {
      this.errMsg = 'Выберите дату'
      return
    }

    if (date.length !== 8 || !moment(date, 'DDMMYYYY').isValid()) {
      this.errMsg = 'Дата введена не корректно'
      return
    }

    this.data.destinyNumb = 0

    let additionNumber1 = 0
    let additionNumber2 = 0
    let additionNumber3 = 0
    let additionNumber4 = 0
    for(let i = 0; i < date.length; i++) additionNumber1 += +date[i]
    for(let i = 0; i < String(additionNumber1).length; i++) additionNumber2 += +String(additionNumber1)[i]
    additionNumber3 = additionNumber1 - ( 2 *  (+date[0] == 0 ? +date[1] : +date[0]))
    additionNumber3 = additionNumber3 > 0 ? additionNumber3 : additionNumber3 * -1
    for(let i = 0; i < String(additionNumber3).length; i++) additionNumber4 += +String(additionNumber3)[i]

    const line = String(date) + additionNumber1 + additionNumber2 + additionNumber3 + additionNumber4


    if (additionNumber2 > 9 && additionNumber2 !== 11) {
      for(let i = 0; i < String(additionNumber2).length; i++) this.data.destinyNumb += +String(additionNumber2)[i]
    } else this.data.destinyNumb = additionNumber2

    this.calculateMatrix(line)
  }

  calculateMatrix(line) {
    if ((!line || !this.data.destinyNumb)) {
      this.errMsg = 'Заполните все поля'
      return
    }

    this.errMsg = ''

    this.data.character = 0
    this.data.energy = 0
    this.data.interest = 0
    this.data.health = 0
    this.data.logic = 0
    this.data.work = 0
    this.data.luck = 0
    this.data.dolg = 0
    this.data.memory = 0
    this.data.temp = 0
    this.data.goal = 0
    this.data.byt = 0
    this.data.fam = 0
    this.data.habits = 0

    for (let j = 0; j < line.length; j++) {
      switch(line[j]) {
        case '1':
          this.data.character += 1
          break;
        case '2':
          this.data.energy += 1
          break;
        case '3':
          this.data.interest += 1
          break;
        case '4':
          this.data.health += 1
          break;
        case '5':
          this.data.logic += 1
          break;
        case '6':
          this.data.work += 1
          break;
        case '7':
          this.data.luck += 1
          break;
        case '8':
          this.data.dolg += 1
          break;
        case '9':
          this.data.memory += 1
          break;
      }
    }

    this.data.temp = this.data.interest + this.data.logic + this.data.luck
    this.data.goal = this.data.character + this.data.health + this.data.luck
    this.data.byt = this.data.health + this.data.logic + this.data.work
    this.data.fam = this.data.energy + this.data.logic + this.data.dolg
    this.data.habits = this.data.interest + this.data.work + this.data.memory

    this.status = 'show'
  }

  returnString(val: number, text: string) {
    let str = ''
    for (let i = 0; i < val; i++) str += text
    return str
  }

  resetData() {
    this.matrixField.setValue(null)
  }

}
